export default __webpack_public_path__ + "static/media/tete45.6f9332b3.png";